import { Alert, Button, IconButton } from "@mui/material"
import useRoles from "../../../../hooks/roles"
import { Add, Delete } from "@mui/icons-material"
import { GenericList } from "../../../common/generic-list/generic-list"
import { IRole } from "../../../../interfaces/common/roles"
import GenericTable from "../../../common/generic-table/generic-table"
import { useState } from "react"
import { RoleModal } from "./role-modal"
import { useSnackBar } from "../../../../contexts/snackbar"
import ConfirmAction from "../../../common/confirm-action/confirm-action"
import { Edit } from "lucide-react"
import { usePermissions } from "../../../../hooks/permissions"

export const PermissionGroups = () => {
    const {roles, fetchRoles, isLoading, createRole, updateRole, deleteRole } = useRoles()
    const { permissions, isLoading: permsLoading } = usePermissions();
    
    const [creatingNewGroup, setCreatingNewGroup] = useState(false)

    const [deletingGroup, setDeletingGroup] = useState<IRole | null>(null)
    const [editingGroup, setEditingGroup] = useState<IRole | null>(null)

    const {showMessage} = useSnackBar()

    return <>
        <Button sx={{mb: 2}} variant="outlined" startIcon={<Add />} onClick={()=>setCreatingNewGroup(true)}>Add New</Button>

        <GenericTable<IRole>
            items={roles}
            fullWidth
            columns={[
                {
                    id: "id",
                    header: "Group #",
                    display_body: (r)=>r.id,
                },
                {
                    id: "name",
                    header: "Name",
                    display_body: (r) => r.name,
                },
                {
                    id: "description",
                    header: "Description",
                    display_body: (r) => r.description,
                },
                {
                    id: "permissions_count",
                    header: "Permissions",
                    display_body: (r) => r.permissions.length
                },
                {
                    id: 'edit',
                    header: "Edit",
                    display_body: (r) => <IconButton onClick={()=>setEditingGroup(r)}><Edit /></IconButton>
                },
                {
                    id: "delete",
                    header: "Delete",
                    display_body: (r) => <IconButton  onClick={()=>setDeletingGroup(r)}><Delete sx={{cursor: "pointer"}} color={"error"}/></IconButton>
                }
            ]}
            isLoading={isLoading}
            getItemUID={(r) => r.id.toString()} 
            selectedItems={new Map} 
            sourceView={""} 
        />

        {creatingNewGroup && <RoleModal 
            isLoading={isLoading || permsLoading}
            permissions={permissions}
            createRole={createRole}
            updateRole={updateRole}
            onClose={()=>setCreatingNewGroup(false)} onSuccess={()=>{
                showMessage("Group saved!", "success");
                fetchRoles()
                setCreatingNewGroup(false);
        }}/>}

        {editingGroup && <RoleModal 
            isLoading={isLoading || permsLoading}
            createRole={createRole}
            updateRole={updateRole}
            permissions={permissions}
            defaultRole={editingGroup}
            onClose={()=>setEditingGroup(null)} 
            onSuccess={()=>{
                showMessage("Group saved!", "success");
                fetchRoles()
                setEditingGroup(null);
        }}/>}

        {
            deletingGroup && <ConfirmAction
                    action={async () => {
                      const success = await deleteRole(deletingGroup.id)
                      if (!success) {
                        showMessage("Failed to delete permission group.", "error")
                      } else {
                        showMessage("Permission group deleted successfully.", "success")
                      }
                    }} 
                    message={"Do you confirm deleting this permission group?"} 
                    isOpen={deletingGroup != null} 
                    handleClose={()=>setDeletingGroup(null)}                
                >
                    <Alert severity="warning">Deleting this permission group will remove the applied permissions from all users belonging to this group.</Alert>
                </ConfirmAction>

        }
    </>
}